(function(angular){
	'use strict';
	
	var plaidBankGridObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			plaidObject: '<'
		},
		controller: [
			'mixpanelFactory',
			'STATIC_BASE_PATH',
			PlaidBankGridFunction
		],
		controllerAs: 'grid'
	};
	
	angular
		.module('baseCheckoutModule')
		.component('plaidBankGrid', plaidBankGridObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/checkout/plaid-bank-grid.html';
	}
	
	function PlaidBankGridFunction(
		mixpanelFactory,
		STATIC_BASE_PATH
	){
		var grid = this;

		grid.handleClick = function(institutionId) {
			grid.plaidObject.open(institutionId);
			mixpanelFactory.track('Plaid Link Started');
		};

		grid.$onInit = function() {
			grid.banks = [
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/bank-of-america.svg',
					institutionId: 'ins_1',
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/chase.svg',
					institutionId: 'ins_3'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/wells-fargo.svg',
					institutionId: 'ins_4'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/ally-sm2.svg',
					institutionId: 'ins_25'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/usaa.svg',
					institutionId: 'ins_7'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/pnc.svg',
					institutionId: 'ins_13'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/citi.svg',
					institutionId: 'ins_5'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/charles-schwab.svg',
					institutionId: 'ins_11'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/td.svg',
					institutionId: 'ins_14'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/usbank2.svg',
					institutionId: 'ins_6'
				},
				{
					icon: STATIC_BASE_PATH + '/interface/institutions/navy-federal.svg',
					institutionId: 'ins_15'
				}
			];
		};
	}
})(window.angular);